<template>
  <div class="site-faq">
    <HeaderMain></HeaderMain>
    <div class="container container-padding">
      <h1 class="heading-top">Frågor och svar</h1>
    </div>
    <main class="wrapper">
      <div class="container">
        <div class="page">
          <p>Inget just nu, titta gärna in senare.</p>
        </div>
      </div>
    </main>
    <FooterMain></FooterMain>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'SiteFaq',
  components: {
    HeaderMain,
    FooterMain
  },
  mounted () {
    document.title = 'Gluo - Frågor och svar'
  }
}
</script>
